import ColorListPage from "@/pages/ColorListPage";

export default function ClientsPage() {
  return (
    <ColorListPage
      title="Clients"
      singular="Client"
      endpoint="/clients"
      defaultColor="#145c8c"
      testidPrefix="client"
    />
  );
}
